module.exports = __webpack_public_path__ + "static/media/twitter.4e1ca695.svg";